import {
  selectConfiguracionEntidad,
} from 'store/auth';
import store from 'store/store';

export default () => {
  const _entidadInfo = selectConfiguracionEntidad(store.getState());

  if (!_entidadInfo) {
    return null;
  }

  return _entidadInfo;
};
